import { Component, AfterViewInit, inject } from '@angular/core';
import { AuthService } from '../../../authentication/auth.service';
import { LoadingService } from '../../../shared/services/loading.service';
import { AlertService } from '../../../shared/services/alert.service';
import { PageFooterComponent } from '../page-footer/page-footer.component';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss'],
  imports: [PageFooterComponent, MatButtonModule],
  standalone: true,
})
export class LogInPageComponent implements AfterViewInit {
  private auth = inject(AuthService);
  private loadingService = inject(LoadingService);
  private alertService = inject(AlertService);

  ngAfterViewInit(): void {
    this.loadingService.hide();
  }

  /**
   * log in if inputs valid; otherwise display informative alerts
   */
  logInUser(emailElementId: string, passwordElementId: string): void {
    const email = (<HTMLInputElement>document.getElementById(emailElementId))
      .value;
    const password = (<HTMLInputElement>(
      document.getElementById(passwordElementId)
    )).value;

    if (
      !(
        email != '' &&
        email.indexOf('@') > 0 &&
        email.indexOf('@') != email.length - 1
      )
    ) {
      this.alertService.showAlert({ message: 'Invalid email.' });
    } else {
      this.auth.logInUser(email, password);
    }
  }

  onEnterPress() {
    this.logInUser('txtEmail', 'txtPassword');
  }
}
